import { EcommPanelParams } from './useEcommData';
import { MaterialsModalParams } from '../SearchMaterialsModal';
import { DeleteProgramModalParams } from '../DeleteProgramModalWrapper';
import useModalPanelState from './useModalPanelState';
import { AddToCalendarParams } from '../../Modal/AddToCalendarModal';

export type SearchModalPanelState = ReturnType<typeof useSearchModalPanelState>;

const useSearchModalPanelState = () => {
  const ecommPanel = useModalPanelState<EcommPanelParams>();
  const materialsModal = useModalPanelState<MaterialsModalParams>();
  const addToCalendarModal = useModalPanelState<AddToCalendarParams>();
  const deleteModal = useModalPanelState<DeleteProgramModalParams>();

  return {
    ecommPanel,
    materialsModal,
    addToCalendarModal,
    deleteModal
  };
};

export default useSearchModalPanelState;
